import React from 'react'
import styled from 'styled-components'
import { InvestAccount } from '@ally/data-types-accounts'
import { Box } from '@ally/metronome-ui'
import { asCurrency } from '@ally/aos-utils'
import AccountDetailsLink from '../AccountDetailsLink'
import { STALE_DATA_COPY } from '../../constants'
import { getDashDash } from '../../utils'
import LegacyMobileCardDetail from './LegacyMobileCardDetail'

const StyledAccountDetailsLink = styled(AccountDetailsLink)`
  width: 100%;
  justify-content: flex-start;
`

const TotalAvailableBalance: React.FC<{
  accounts: InvestAccount[]
  hasStaleData?: boolean
}> = ({ accounts, hasStaleData }) => {
  const total = accounts.reduce((sum: number, account: InvestAccount) => {
    return account.accountValueTotal + sum
  }, 0)

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      borderLeftStyle="solid"
      borderLeftWidth="7px"
      py="sm"
      px="xs"
      borderTop="1px solid"
      borderTopColor="slate-2"
      width="100%"
      borderBottom="1px solid"
      borderBottomColor="slate-2"
    >
      <Box fontWeight="bold" style={{ textTransform: 'uppercase' }}>
        Total
      </Box>
      <Box fontWeight="bold">
        {hasStaleData ? getDashDash(STALE_DATA_COPY) : asCurrency(total)}
      </Box>
    </Box>
  )
}

const MobileInvestAccountList: React.FC<{
  accounts: InvestAccount[]
  allClosedAccounts: boolean
  hasStaleData?: boolean
}> = ({ accounts, allClosedAccounts, hasStaleData }) => {
  return (
    <>
      {accounts.map((account: InvestAccount) => {
        const content = (
          <LegacyMobileCardDetail
            account={account}
            key={`detail-${account.webId}`}
            hasStaleData={hasStaleData}
          />
        )

        return (
          <StyledAccountDetailsLink
            accountType={account.accountType}
            webId={account.webId}
            text={content}
            key={account.webId}
            accountNickname={account.accountNickname}
            accountNumberPvtEncrypt={account.accountNumberPvtEncrypt}
            hasStaleData={hasStaleData}
          />
        )
      })}
      {!allClosedAccounts && (
        <TotalAvailableBalance
          accounts={accounts}
          hasStaleData={hasStaleData}
        />
      )}
    </>
  )
}

export default MobileInvestAccountList
